import { render, staticRenderFns } from "./ForgivePriceReport.vue?vue&type=template&id=7bb0d320&"
import script from "./ForgivePriceReport.vue?vue&type=script&lang=js&"
export * from "./ForgivePriceReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports